import { render, staticRenderFns } from "./ManageSeller.vue?vue&type=template&id=2de350d7&scoped=true"
import script from "./ManageSeller.vue?vue&type=script&lang=js"
export * from "./ManageSeller.vue?vue&type=script&lang=js"
import style0 from "./ManageSeller.vue?vue&type=style&index=0&id=2de350d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de350d7",
  null
  
)

export default component.exports